module.exports = {
  CARRIER_FNP: 'CARRIER_FNP',
  COMPLIANCE_EXCEPTION_SC: 'COMPLIANCE_EXCEPTION_SC',
  CONSIGNMENT: 'CONSIGNMENT',
  DESPATCH: 'DESPATCH',
  EDI_EXCHANGE_OVERVIEW: 'EDI_EXCHANGE_OVERVIEW',
  EDI_COMPLIANCE: 'EDI_COMPLIANCE',
  EDI_MESSAGES: 'EDI_MESSAGES',
  MRD: 'MRD',
  OUC: 'OUC',
  PAPER_FREE: 'PAPER_FREE',
  TRANSPORT: 'TRANSPORT',
  NO_GROUP: 'NO_GROUP',
  KPI: 'KPI',
  KIP: 'KIP',
  IRREGULARITIES: 'IRREGULARITIES',
  MONITORING: 'MONITORING',
  CARRIER: 'CARRIER',
  HANDLER: 'HANDLER',
  EDI_EXCHANGE: 'EDI_EXCHANGE',
  CARDIT: 'CARDIT',
  EPG: 'EPG',
  USER_MONITORING: 'USER_MONITORING',
  ITEM: 'ITEM',
  CERTIFICATION: 'CERTIFICATION',
};
